// 计划 API 模块
import { API_BASE_URL } from '../config'

// 统一响应格式
interface ApiResponse<T> {
  code: number
  message?: string
  data?: T
}

// 计划类型 type 数值（前端 PlanType 字符串对应）
// 1-周计划  2-月计划  3-季度计划  4-年计划
export type PlanTypeKey = 'week' | 'month' | 'quarter' | 'year'

export const PLAN_TYPE_MAP: Record<PlanTypeKey, number> = {
  week: 1,
  month: 2,
  quarter: 3,
  year: 4,
}

export const PLAN_TYPE_REVERSE: Record<number, PlanTypeKey> = {
  1: 'week',
  2: 'month',
  3: 'quarter',
  4: 'year',
}

// 计划对象
export interface Plan {
  id: number
  parent_id: number
  type: number // 1/2/3/4
  title: string
  start_date: string | null
  end_date: string | null
  content?: string
  progress: number
  status: number // 0-进行中 1-已完成 2-已取消
  sort: number
  create_at: number
  update_at: number
}

// 列表请求参数
export interface PlanListParams {
  type?: number
  status?: number
  parent_id?: number
  keyword?: string
}

// 通用请求封装
async function request<T>(url: string, options?: RequestInit): Promise<ApiResponse<T>> {
  const response = await fetch(`${API_BASE_URL}${url}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })
  return response.json()
}

// 获取计划列表
export function getPlanList(params: PlanListParams = {}) {
  const query = new URLSearchParams()
  if (params.type !== undefined) query.append('type', String(params.type))
  if (params.status !== undefined) query.append('status', String(params.status))
  if (params.parent_id !== undefined) query.append('parent_id', String(params.parent_id))
  if (params.keyword) query.append('keyword', params.keyword)
  const qs = query.toString()
  return request<Plan[]>(`/api/plan/list${qs ? '?' + qs : ''}`)
}

// 获取计划详情
export function getPlanDetail(id: number) {
  return request<Plan>(`/api/plan/detail?id=${id}`)
}

// 添加计划
export function addPlan(data: Partial<Plan>) {
  return request<{ id: number }>('/api/plan/add', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

// 编辑计划（基础信息）
export function editPlan(data: Partial<Plan> & { id: number }) {
  return request<null>('/api/plan/edit', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

// 保存详情内容（富文本）
export function savePlanContent(id: number, content: string) {
  return request<null>('/api/plan/save', {
    method: 'POST',
    body: JSON.stringify({ id, content }),
  })
}

// 切换完成状态
export function togglePlan(id: number) {
  return request<{ status: number }>('/api/plan/toggle', {
    method: 'POST',
    body: JSON.stringify({ id }),
  })
}

// 删除计划
export function deletePlan(id: number) {
  return request<null>('/api/plan/delete', {
    method: 'POST',
    body: JSON.stringify({ id }),
  })
}
